import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';

const BLOG_ROUTES = ['/ar7-cheat-sheet', '/price-cap', '/hedging-is-hot'];

export default function NavBar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isBlog = BLOG_ROUTES.includes(location.pathname);

  const links = [
    { to: '/', label: 'Breakdown' },
    { to: '/wholesale', label: 'Wholesale monitor' },
    { to: '/2030', label: '2030 forecast' },
  ];

  return (
    <div className={`nav-bar-wrapper${isBlog ? ' nav-bar-blog' : ''}`}>
      <nav className="nav-bar">
        <div className="nav-top">
          <span className="nav-title">GB Electricity Bills</span>
          <button
            className="nav-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
          </button>
        </div>
        <div className={`nav-links ${menuOpen ? 'nav-links-open' : ''}`}>
          {links.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}
